var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDateCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "date-calendar"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.3,4.9V2.1a.7.7,0,0,1,1.4,0V4.9a.7.7,0,0,1-1.4,0Zm7.4,0V2.1a.7.7,0,0,1,1.4,0V4.9a.7.7,0,0,1-1.4,0Z",
    transform: "translate(-2.6 -1.4)",
    fill: "{props.color}"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9,21.4c-3.4,0-5.3-2-5.3-5.3v-8c0-3.4,2-5.3,5.3-5.3h7.4c3.4,0,5.3,2,5.3,5.3v4.8a.68.68,0,0,1-.4.6.62.62,0,0,1-.7-.1,4.2,4.2,0,0,0-6.8,3.3,3.7,3.7,0,0,0,.6,2.1A4.26,4.26,0,0,0,14.4,20a.83.83,0,0,1,.3.8.75.75,0,0,1-.7.5l-6.1.1ZM4,8.1V16c0,2.7,1.3,4,4,4h4.5c-.1-.1-.2-.3-.3-.4a6,6,0,0,1-.8-2.9,5.8,5.8,0,0,1,2.1-4.4,5.54,5.54,0,0,1,5.8-.7V8.1c0-2.7-1.3-4-4-4H7.9C5.3,4.2,4,5.5,4,8.1Z",
    transform: "translate(-2.6 -1.4)",
    fill: "{props.color}",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8,21.3a5.72,5.72,0,0,1-1.5-1.6,6,6,0,0,1-.8-2.9,5.8,5.8,0,0,1,2.1-4.4,5.56,5.56,0,0,1,6.9,0,5.8,5.8,0,0,1,2.1,4.4,6,6,0,0,1-.8,2.9A6.89,6.89,0,0,1,20.7,21,5.49,5.49,0,0,1,17,22.4,5.86,5.86,0,0,1,13.8,21.3Zm.6-7.8a4.22,4.22,0,0,0-1.6,3.3,3.7,3.7,0,0,0,.6,2.1,4.26,4.26,0,0,0,1.1,1.2,4.08,4.08,0,0,0,5.1-.2,3.92,3.92,0,0,0,.8-1,4.28,4.28,0,0,0,.6-2.2,4.22,4.22,0,0,0-1.6-3.3,3.92,3.92,0,0,0-2.6-.9A5,5,0,0,0,14.4,13.5Z",
    transform: "translate(-2.6 -1.4)",
    fill: "{props.color}",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1.1,
    y: 5.2,
    width: 16.1,
    height: 1.1,
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9,17.4h-.2a.27.27,0,0,1-.3-.3V14.4a.27.27,0,0,1,.3-.3h.2a.27.27,0,0,1,.3.3v2.7A.27.27,0,0,1,16.9,17.4Z",
    transform: "translate(-2.6 -1.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3,18.6l-.1.1c-.1.1-.3.2-.4.1l-2.3-1.4c-.1-.1-.2-.3-.1-.4l.1-.1c.1-.1.3-.2.4-.1l2.3,1.4C19.4,18.2,19.4,18.4,19.3,18.6Z",
    transform: "translate(-2.6 -1.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.45
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-2.6 -1.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateCalendar);
export default __webpack_public_path__ + "static/media/date-calendar.7bde96683342a846774f9a5f7196dd87.svg";
export { ForwardRef as ReactComponent };